export default {
    parent: 'ApplicationLayout',
    template: `
        <header-public class="header-wrapper"></header-public>
        <ui-view class="body-wrapper"></ui-view>
        <footer class="footer-wrapper"></footer>
    `
};



// WEBPACK FOOTER //
// ./src/app/layouts/public/index.js